import { Info, X } from "lucide-react";
import { useState } from "react";
import { Button } from "react-aria-components";

export type KickstarterBannerProps = {
  description: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  primaryButtonOnClick?: () => void;
  primaryButtonText?: string;
  secondaryButtonOnClick?: () => void;
  secondaryButtonText?: string;
  title: string;
};

export function KickstarterBanner({
  description,
  dismissible = true,
  onDismiss,
  primaryButtonOnClick,
  primaryButtonText,
  secondaryButtonOnClick,
  secondaryButtonText,
  title,
}: KickstarterBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false);

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  if (isDismissed) return null;

  return (
    <div className="flex pb-4 justify-center">
      <div className="flex gap-xl rounded-xl border border-border-primary bg-bg-primary-alt p-xl">
        <div className="grid size-4xl shrink-0 place-items-center rounded-full bg-red-100">
          <Info className="text-red-600" size={18} />
        </div>
        <div className="flex flex-1 flex-col gap-xs">
          <span className="text-sm font-semibold">{title}</span>
          <span className="text-sm text-[#101828]">{description}</span>
          {(secondaryButtonText || primaryButtonText) && (
            <div className="flex gap-3 mt-2">
              {secondaryButtonText && (
                <button
                  className="text-sm text-text-tertiary hover:underline cursor-pointer"
                  onClick={secondaryButtonOnClick}
                >
                  {secondaryButtonText}
                </button>
              )}
              {primaryButtonText && (
                <button
                  className="text-sm text-[#5925DC] font-semibold hover:underline cursor-pointer"
                  onClick={primaryButtonOnClick}
                >
                  {primaryButtonText}
                </button>
              )}
            </div>
          )}
        </div>
        {dismissible && (
          <Button
            className="ml-auto grid size-2xl place-items-center self-start"
            onPress={handleDismiss}
          >
            <X
              className="text-utility-blue-600 hover:text-utility-blue-700"
              size={16}
            />
          </Button>
        )}
      </div>
    </div>
  );
}
